<template>
  <v-container fluid>
    <div>
      <h2>設定</h2>
    </div>
    <v-divider class="mb-5" />

    <v-tabs v-model="tab">
      <v-tab>CRM選項管理 </v-tab>
      <v-tab>YOMT代辦服務選項管理</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab" touchless>
      <!-- CRM Settings Tab -->
      <v-tab-item>
        <CRMNotificationSetting />

        <CRMOptions />
      </v-tab-item>

      <!-- Agency Services Tab -->
      <v-tab-item>
        <YOMTOptions />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import CRMOptions from '@/components/Options/CRMOptions';
import YOMTOptions from '@/components/Options/YOMTOptions';
import CRMNotificationSetting from '@/components/SystemConfig/CRMNotificationSetting';

export default {
  name: 'OptionsManagement',
  components: {
    CRMOptions,
    YOMTOptions,
    CRMNotificationSetting,
  },
  data() {
    return {
      tab: null,
    };
  },
};
</script>
